import React from "react";
import "./about.css";
import me from "../../img/formal.jpeg";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const About = () => {
  return (
    <div>
      <div className="a">
        <div className="a-left">
          <div className="a-card bg"></div>
          <div className="a-card">
            <img src={me} alt="" className="a-img" />
          </div>
        </div>
        <div className="a-right">
          <h1 className="a-title">About Me</h1>
          <div className="line"></div>
          <p className="a-sub">
            I am an ambitious and motivated individual pursuing a Master's in
            Information Systems at Northeastern University, aspiring to bridge
            the gap between technology and innovation. 
            As a Software Developer, I have honed my abilities to work both
            independently and within a team, ensuring efficiency and focus in
            every task. My expertise lies in crafting seamless user experiences
            for mobile applications, optimizing performance across various
            screen resolutions. During my time at Philips as a Software
            engineer co-op, I've not only mastered Database Management and
            version control but also gained valuable insights into the Software
            Development Life Cycle and Agile methodologies. 
          </p>
          <p className="a-desc">
          I am dedicated to
            continuously enhancing my programming and web technology skills. I
            am eager to apply my growing knowledge as a full stack developer
            within an engaging and collaborative environment, seeking challenges
            that will expand my network and refine my expertise.
          </p>
          <div className="smedia-wrapper">
            <button>
              <a
                href="mailto:goda.d@northeastern.edu"
                target="_blank"
                rel="noreferrer"
              >
                <MdEmail size="lg" />
              </a>
            </button>
            <button>
              <a
                href="https://github.com/DrishtiGoda"
                target="_blank"
                rel="noreferrer"
              >
                <FaGithub size="lg" />
              </a>
            </button>
            <button>
              <a
                href="https://www.linkedin.com/in/drishtigoda/"
                target="_blank"
                rel="noreferrer"
              >
                <FaLinkedinIn size="lg" />
              </a>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
